export default {
  items: [
    {
      title: 'chat.nav.title',
      id: 'Chat',
      to: null,
      icon: 'icon',
      sortOrder: 10,
      expanded: true,
      permission: 'chat access',
      children: [
        {
          title: 'chat.nav.title',
          to: { name : 'ChatIndexPage'},
          icon: 'user',
          sortOrder: 10,
          permission: 'chat access',
        },
        {
          title: 'chat.admin.title',
          id: 'ChatAdmin',
          to: null,
          icon: 'shield',
          sortOrder: 20,
          permission: 'chat administer',
          children: [
            {
              title: 'chat.admin.authorization',
              to: { name : 'ChatAdminAuthorizationPage'},
              icon: 'shield',
              sortOrder: 10,
              permission: 'chat administer',
            },
            {
              title: 'chat.admin.conversations',
              to: { name : 'ChatAdminConversationsPage'},
              icon: 'message-square',
              sortOrder: 20,
              permission: 'chat administer',
            },
            {
              title: 'chat.admin.userAccess',
              to: { name : 'ChatAdminUserAccessPage'},
              icon: 'users',
              sortOrder: 30,
              permission: 'chat administer',
            },
          ],
        }
      ]
    }
  ]
}
